import { EnforcedThemeStateContext } from '@rhg/providers/enforced-theme-provider';
import { useContext } from 'react';

export function useEnforcedThemeState() {
    return useContext(EnforcedThemeStateContext);
}
